import { render } from "./Transportistas.vue?vue&type=template&id=e34a0318&scoped=true"
import script from "./Transportistas.vue?vue&type=script&lang=ts"
export * from "./Transportistas.vue?vue&type=script&lang=ts"

import "./Transportistas.vue?vue&type=style&index=0&id=e34a0318&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e34a0318"

export default script